export const useFetchFolderFromStoryblok = async <T>(
  starts_with: string,
  resolve_relations?: string[]
): Promise<T[]> => {
  const runtimeConfig = useRuntimeConfig()
  const { locale } = useI18n()
  const language = locale.value === 'en' ? 'default' : locale.value

  const storyblokApiInstance = useStoryblokApi()
  return await storyblokApiInstance.getAll('cdn/stories', {
    starts_with,
    version: runtimeConfig.public.env === 'development' ? 'draft' : 'published',
    language,
    resolve_relations
  })
}
